import React from 'react'
import { observer } from 'mobx-react'

import TabStore from 'stores/tab/TabStore'
import LayoutStore from 'stores/layout/LayoutStore'
import ErrorStore from 'stores/error/ErrorStore'

import Header from 'components/header/Header'
import ClientError from 'components/error/ClientError'
import FatalError from 'components/error/FatalError'
import Databrowser from 'components/databrowser/Databrowser'
import ModelListTab from 'components/modelListTab/ModelListTab'

import createError from 'utils/createError'

import styles from './layout.scss'

interface IProps {}

interface IState {
  error: boolean
}

class Layout extends React.PureComponent<IProps, IState> {
  state: IState = {
    error: false,
  }

  componentDidCatch(error: Error) {
    ErrorStore.update({
      type: 'fatal',
      description: error.message,
      dump: error.stack || '',
    })
    LayoutStore.updateError({ visible: true })

    createError(
      'Studio.componentDidCatch',
      'Caught an error during rendering',
      {},
      error
    )
  }

  static getDerivedStateFromError(e: Error) {
    return {
      error: true,
      errorMessage: e.message,
    }
  }

  render() {
    const { error } = this.state

    if (error) {
      return <FatalError />
    }

    return (
      <div className={styles.container}>
        <Header className={styles.header} />
        <div className={styles.body}>
          {TabStore.activeTab?.session?.isScript && <Databrowser />}
          {TabStore.activeTab?.session?.isModelList && <ModelListTab />}
        </div>
        {LayoutStore.error.visible && ErrorStore.type === 'client' && (
          <ClientError />
        )}
        {LayoutStore.error.visible && ErrorStore.type === 'fatal' && (
          <FatalError />
        )}
      </div>
    )
  }
}

export default observer(Layout)
